module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"app":{"submitted":"Online application has been submitted."},"labels":{"submit":"Submit for review"},"button":{"openNextTask":"Open next task"}}}')
  delete Component.options._Ctor
}
